import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import routes from "common/routes";

export const CHECK_NEW_CHANGES_INTERVAL_MINUTES = 3;

export const facilityGetOptions = [
  "Facility.id",
  "Facility.name",
  "Facility.code",
  "Facility.backgroundColor"
];

export const listCoursesGetOptions = [
  "id",
  "name",
  "surface",
  "trackCondition",
  "previousTrackCondition",
  "active",
  "comment",
  "created_on",
  "updated_on",
  "isOnlyCommentUpdated",
  ...facilityGetOptions
];

export const conditionsLabels = {
  [racehorse360.TrackCondition.TRACK_CONDITION_INVALID]: "Invalid",
  [racehorse360.TrackCondition.TRACK_CONDITION_FAST]: "Fast",
  [racehorse360.TrackCondition.TRACK_CONDITION_FIRM]: "Firm",
  [racehorse360.TrackCondition.TRACK_CONDITION_FROZEN]: "Frozen",
  [racehorse360.TrackCondition.TRACK_CONDITION_GOOD]: "Good",
  [racehorse360.TrackCondition.TRACK_CONDITION_HARD]: "Hard",
  [racehorse360.TrackCondition.TRACK_CONDITION_HEAVY]: "Heavy",
  [racehorse360.TrackCondition.TRACK_CONDITION_MUDDY]: "Muddy",
  [racehorse360.TrackCondition.TRACK_CONDITION_SLOPPY]: "Sloppy",
  [racehorse360.TrackCondition.TRACK_CONDITION_SLOW]: "Slow",
  [racehorse360.TrackCondition.TRACK_CONDITION_SOFT]: "Soft",
  [racehorse360.TrackCondition.TRACK_CONDITION_WET_FAST]: "Wet Fast",
  [racehorse360.TrackCondition.TRACK_CONDITION_YIELDING]: "Yielding",
  [racehorse360.TrackCondition.TRACK_CONDITION_STANDARD]: "Standard",
  [racehorse360.TrackCondition.TRACK_CONDITION_WET]: "Wet",
  [racehorse360.TrackCondition.TRACK_CONDITION_DEAD]: "Dead",
  [racehorse360.TrackCondition.TRACK_CONDITION_EASY]: "Easy",
  [racehorse360.TrackCondition.TRACK_CONDITION_GOOD_TO_FIRM]: "Good to Firm",
  [racehorse360.TrackCondition.TRACK_CONDITION_GOOD_TO_SOFT]: "Good to Soft",
  [racehorse360.TrackCondition.TRACK_CONDITION_UNKNOWN]: "Unknown"
};

export type FacilityData = {
  [key: string]: racehorse360.IFacility;
};

export type CourseData = {
  [key: string]: racehorse360.ICourse;
};

export type ChangesData = {
  isNoteChanged?: boolean;
  isTrackConditionChanged?: boolean;
};

export type FacilityCourse = {
  facility: racehorse360.IFacility;
  courses: racehorse360.ICourse[];
};

export type FacilityCourses = {
  [key: string]: FacilityCourse;
};

export const conditionsBySurfaceType = {
  synthetic: [
    racehorse360.TrackCondition.TRACK_CONDITION_FAST,
    racehorse360.TrackCondition.TRACK_CONDITION_SLOW,
    racehorse360.TrackCondition.TRACK_CONDITION_STANDARD
  ],
  turf: [
    racehorse360.TrackCondition.TRACK_CONDITION_DEAD,
    racehorse360.TrackCondition.TRACK_CONDITION_EASY,
    racehorse360.TrackCondition.TRACK_CONDITION_FIRM,
    racehorse360.TrackCondition.TRACK_CONDITION_FAST,
    racehorse360.TrackCondition.TRACK_CONDITION_GOOD,
    racehorse360.TrackCondition.TRACK_CONDITION_GOOD_TO_FIRM,
    racehorse360.TrackCondition.TRACK_CONDITION_GOOD_TO_SOFT,
    racehorse360.TrackCondition.TRACK_CONDITION_HARD,
    racehorse360.TrackCondition.TRACK_CONDITION_HEAVY,
    racehorse360.TrackCondition.TRACK_CONDITION_MUDDY,
    racehorse360.TrackCondition.TRACK_CONDITION_SOFT,
    racehorse360.TrackCondition.TRACK_CONDITION_SLOW,
    racehorse360.TrackCondition.TRACK_CONDITION_UNKNOWN,
    racehorse360.TrackCondition.TRACK_CONDITION_WET,
    racehorse360.TrackCondition.TRACK_CONDITION_YIELDING
  ],
  dirt: [
    racehorse360.TrackCondition.TRACK_CONDITION_FAST,
    racehorse360.TrackCondition.TRACK_CONDITION_FROZEN,
    racehorse360.TrackCondition.TRACK_CONDITION_GOOD,
    racehorse360.TrackCondition.TRACK_CONDITION_HEAVY,
    racehorse360.TrackCondition.TRACK_CONDITION_MUDDY,
    racehorse360.TrackCondition.TRACK_CONDITION_SLOW,
    racehorse360.TrackCondition.TRACK_CONDITION_STANDARD,
    racehorse360.TrackCondition.TRACK_CONDITION_SLOPPY,
    racehorse360.TrackCondition.TRACK_CONDITION_WET_FAST,
    racehorse360.TrackCondition.TRACK_CONDITION_WET
  ]
};

export enum APPS {
  TrackConditions = "TrackConditions",
  WorkoutScheduling = "WorkoutScheduling",
  FacilitySelector = "FacilitySelector",
  ApplicationSelector = "ApplicationSelector"
}

export const APPSRoutes = {
  TrackConditions: routes.manageTracksTrackConditions.path,
  WorkoutScheduling: routes.manageTracksWorkoutScheduling.path,
  FacilitySelector: routes.manageTracks.path,
  ApplicationSelector: routes.manageTracksFacility.path,
  PageTitle: routes.manageTracks.moduleName
};
